import React from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';

// components
import { FormField, FormInput } from '@ui';

const InnerForm = () => {
  const { t } = useTranslation('accounts');

  return (
    <>
      <FormField
        name="accountNickname"
        label={t(
          'account_activity.account_details.update_nickname_modal.form_fields.nickname',
        )}
        component={FormInput}
      />
    </>
  );
};

export default InnerForm;
